import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Grid, Row, Button } from 'react-bootstrap';
import logo2 from '../../assets/img/logo_macizo1.png';
import TextFieldGroup from '../TextFieldGroup/TextFieldGroup';
//import { rutas } from '../../routes_backend/routes';
import { resetPassword } from '../../setup/users/actions.js';
import PropTypes from 'prop-types';

export class ForgotPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: '',
			password: '',
			passwordConfirm: '',
			email: '',
			message: '',
			message_email: '',
			message_token: '',
			message_password: '',
			message_passwordConfirm: '',
			disabled: false
		};
		this.onChange = this.onChange.bind(this);
	}
	onChange(event) {
		this.setState({ [event.target.name]: event.target.value });
	}

	onSubmit = (token, password, passwordConfirm) => {
		this.setState({
			message: '',
			message_email: '',
			message_token: '',
			message_password: '',
			message_passwordConfirm: ''
		});
		if (this.state.email === '') {
			return this.setState({
				message_email: 'Ingrese E-mail'
			});
		}
		if (this.state.token === '') {
			return this.setState({
				message_token: 'Ingrese token'
			});
		}
		if (this.state.password === '') {
			return this.setState({
				message_password: 'Ingrese password'
			});
		}
		if (this.state.passwordConfirm === '') {
			return this.setState({
				message_passwordConfirm: 'Ingrese la confirmacion de tu password'
			});
		}
		if (passwordConfirm !== password) {
			return this.setState({
				message_passwordConfirm: 'Las contraseñas no son iguales',
				message_password: 'Las contraseñas no son iguales'
			});
		}
		this.props.resetPassword(this.state.email, password, token).then(() => {
			let data = this.props.resetpassword;
			if (data === 'Contraseña actualizada exitosamente') {
				this.setState({
					disabled: true
				});
			}
			this.setState({
				message: data
			});
		});
		//jNx6Vndg9n
		/* let url = `${rutas.reset_password}?email=${this.state.email}&password=${password}&token=${token}`;
		fetch(url)
			.then(async (res) => {
				let data = await res.json();
				if (data === 'Contraseña actualizada exitosamente') {
					this.setState({
						disabled: true
					});
				}
				this.setState({
					message: data
				});
			})
			.catch((error) => {
				console.log(error);
				this.setState({
					message: 'error in the server'
				});
			}); */
		//this.props.history.push('/');
	};
	login = () => {
		this.props.history.push('/');
		this.setState({
			token: '',
			password: '',
			passwordConfirm: '',
			email: '',
			message: '',
			message_email: '',
			message_token: '',
			message_password: '',
			message_passwordConfirm: '',
			disabled: false
		});
	};
	render() {
		const {
			message,
			token,
			password,
			passwordConfirm,
			email,
			message_email,
			message_token,
			message_password,
			message_passwordConfirm,
			disabled
		} = this.state;
		return (
			<div>
				{' '}
				<div className="col-md-4 col-md-offset-4">
					<div className="content">
						<Grid>
							<Row>
								<div className="col-md-6">
									<div className="jumbotron jumbotron-fluid">
										<div className="content">
											<div className="logo-img">
												<img style={styles.logo} src={logo2} alt="Logo SFSUPD" />
											</div>
											<br />
											<h3 align="center" className="display-4">
												Resetear Contraseña
											</h3>
											<br />
											<div style={styles.animation}>
												{message ? (
													<div
														className={
															message === 'Contraseña actualizada exitosamente' ? (
																'alert alert-success'
															) : (
																'alert alert-danger'
															)
														}
														role="alert"
													>
														{message}
													</div>
												) : null}
											</div>
											<Col style={styles.animation}>
												<TextFieldGroup
													field="email"
													label="E-mail Macizo"
													type="email"
													name="email"
													value={email ? email : ''}
													onChange={this.onChange}
													error={message_email}
													disabled={disabled}
												/>
											</Col>
											<Col style={styles.animation}>
												<TextFieldGroup
													field="token"
													label="Token"
													type="token"
													name="token"
													value={token ? token : ''}
													onChange={this.onChange}
													error={message_token}
													disabled={disabled}
												/>
											</Col>
											<Col style={styles.animation}>
												<TextFieldGroup
													field="password"
													label="Nuevo Password"
													type="password"
													name="password"
													value={password ? password : ''}
													onChange={this.onChange}
													error={message_password}
													disabled={disabled}
												/>
											</Col>{' '}
											<Col style={styles.animation}>
												<TextFieldGroup
													field="passwordConfirm"
													label="Confirmar Password"
													type="password"
													name="passwordConfirm"
													value={passwordConfirm ? passwordConfirm : ''}
													onChange={this.onChange}
													error={message_passwordConfirm}
													disabled={disabled}
												/>
											</Col>
											<div style={{ display: 'flex', justifyContent: 'center' }}>
												<Button
													bsStyle="primary"
													bsSize="large"
													active
													onClick={
														message === 'Contraseña actualizada exitosamente' ? (
															this.login
														) : (
															() => this.onSubmit(token, password, passwordConfirm)
														)
													}
												>
													{message === 'Contraseña actualizada exitosamente' ? (
														'Login'
													) : (
														'Actualizar'
													)}
												</Button>
											</div>
										</div>
									</div>
								</div>
							</Row>
						</Grid>
					</div>
				</div>
			</div>
		);
	}
}

ForgotPassword.protoTypes = {
	resetPassword: PropTypes.func.isRequired,
	resetpassword: PropTypes.object.isRequired
};

ForgotPassword.contextTypes = {};

function mapStateToProps(state) {
	return {
		resetpassword: state.resetpassword.resetpassword
	};
}
export default connect(mapStateToProps, { resetPassword })(ForgotPassword);
const styles = {
	wrapperContainer: {
		display: 'flex',
		flexWrap: 'flexWrap',
		alignItems: 'flex-end'
	},
	animation: {
		transition: 'all 1s ease'
	},
	WrapperContent: {
		margin: 'auto',
		width: '100%',
		padding: '1em 12em'
	},
	styleHeaderForgotPassword: {
		display: 'flex',
		flexWrap: 'flexWrap',
		alignItems: 'center'
	},
	textHeaderForgot: {
		display: 'flex'
	},
	wrapperLogo: {
		display: 'flex',
		flexWrap: 'flexWrap',
		width: '56%',
		justifyContent: 'flex-end',
		alignContent: 'center',
		padding: '1em auto'
	},
	logo: {
		width: '50%',
		marginLeft: '25%'
	},
	logoToken: {
		height: '2.5em',
		width: 'auto'
	},
	styleForgotMessage: {
		fontSize: '1.5rem',
		cursor: 'pointer',
		color: '#g5g5g5',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	backBotton: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignContent: 'base-line',
		cursor: 'pointer'
	}
};
